import deepmerge from 'deepmerge';
import Vue from 'vue';
import Card from '../Card/Card';
import Form from '../Form/Form';
import RecordCard from '../GenericTable/RecordCard/RecordCard';
export default Vue.extend({
    components: { Card, Form, RecordCard },
    props: {
        titleProp: { type: String },
        rootComponentProp: { type: Function },
        rootComponentPropsProp: { type: Object },
        rootComponentStyles: { type: String },
        //
        cardProps: { type: Object },
        formProps: { type: Object },
        recordCardProps: { type: Object },
        visibleProp: { type: Boolean },
        qDialogProps: { type: Object },
        componentForHeaderSlotProp: { type: Function },
        componentForHeaderSlotPropsProp: { type: Object },
        componentForBodySlotProp: { type: Function },
        componentForBodySlotPropsProp: { type: Object },
        componentForFooterSlotProp: { type: Function },
        componentForFooterSlotPropsProp: { type: Object },
        executeAfterDialogCloseProp: { type: Function }
    },
    data() {
        return {
            visible: false,
            executeAfterDialogClose: undefined,
            passedOpenParams: undefined
        };
    },
    computed: {
        computedQDialogProps() {
            var _a;
            return ((_a = this.passedOpenParams) === null || _a === void 0 ? void 0 : _a.qDialogProps) || this.qDialogProps;
        },
        computedRecordCardProps() {
            var _a;
            const res = ((_a = this.passedOpenParams) === null || _a === void 0 ? void 0 : _a.recordCardProps) || this.recordCardProps;
            return res ? Object.assign(Object.assign({}, res), { doNotGoToPreviousMode: true }) : undefined;
        },
        computedCardProps() {
            var _a;
            const defaults = {
                titleProp: this.titleProp,
                styleProp: 'min-width:560px',
                bodyCardSectionStyles: 'padding-top:0;max-height:calc(100vh - 150px);overflow-y:scroll;',
                showCloseButtonInUpperRightCornerProp: true
            };
            return deepmerge(defaults, ((_a = this.passedOpenParams) === null || _a === void 0 ? void 0 : _a.cardProps) || this.cardProps || {});
        },
        computedFormProps() {
            var _a;
            return ((_a = this.passedOpenParams) === null || _a === void 0 ? void 0 : _a.formProps) || this.formProps; // reason why we don't add || {} here is because visibility of Form component in GenericDialog depends on truthy value of this prop
        }
    },
    watch: {
        visibleProp: {
            immediate: true,
            handler(newVal, oldVal) {
                if (Boolean(newVal) === this.visible)
                    return;
                this.visible = Boolean(newVal);
            }
        },
        visible: {
            immediate: true,
            handler(newVal, oldVal) {
                if (Boolean(newVal) === Boolean(oldVal))
                    return;
                if (Boolean(newVal) === false) {
                    this.$emit('hide'); // used by utils/openDialog.ts
                }
                else if (Boolean(newVal) === true) {
                    this.$emit('open');
                }
            }
        }
    },
    methods: {
        open() {
            this.visible = true;
            return this; // used for access by outside objects
        },
        close() {
            this.visible = false;
            if (typeof this.executeAfterDialogCloseProp === 'function')
                this.executeAfterDialogCloseProp();
        },
        openDialog() { this.open(); },
        closeDialog() { this.close(); }
    }
});
